// extracted by mini-css-extract-plugin
module.exports = {"intent":"IntentStatistics_intent__1c-5P","count":"IntentStatistics_count__3hyFu","ratio":"IntentStatistics_ratio__2LVjD"};